import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import createRequestPassword from './createRequestPassword';

export default function useRequestPassword() {
  const navigate = useNavigate();

  return useMutation({
    mutationKey: ['request-password'],
    mutationFn: (payload) =>
      createRequestPassword({
        ...payload,
      }),
    onSuccess: () => {
      navigate('/password-request-success', {
        replace: true,
        state: { emailSent: true },
      });
    },
  });
}
